import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { getReportTypeMessage } from "reports/shared/utils/util";

const ReportType = ({ reportType }) => {
  const { formatMessage } = useIntl();
  const messageIntl = getReportTypeMessage(reportType);
  return <span>{formatMessage(messageIntl)}</span>;
};

ReportType.propTypes = {
  reportType: PropTypes.string,
};

export default ReportType;
